<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li class="active"><a>Licenses</a></li>
  </ul>
  <div class="right">
    <span>{{today}}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
    <div class="content_view">
      <div class="row">
        <div class="col-md-12">
          <div class="license_outer">
              <div class="license_filter_div">
                <div class="left">
                    <h4>Available Device License Type</h4>
                    <div class="lf_rg_detail">
                      <ul>
                        <li>Total Available ({{infoForTab.device_type || 0}}) Licenses: <span>{{infoForTab?.total_available_licenses || '0'}}</span></li>
                        <li>Committed (sold) Licenses: <span>{{infoForTab?.commited_licenses || '0'}}</span></li>
                        <li>Active Licenses: <span>{{infoForTab?.active_license || '0'}}</span></li>
                      </ul>
                    </div>
                </div>
                <div class="right">
                  <span class="custom_select_outer m_r_16">
                    <select  class="custom_select form-control width_120" (change)="selectDeviceType1('select2')" id="select2">
                      <option *ngFor="let licenseList of availableLicenseList" [(value)]="licenseList.device_type">{{licenseList.device_type}}</option>
                    </select>
                  </span>
                    <button mat-raised-button color="primary" (click)="addLicense()">
                      <span class="sprite_icon plus_white"></span>
                      <span>Add licenses</span>
                    </button>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-hover unbordered_tb">
                  <thead>
                    <tr>
                      <th>Customer</th>
                      <th>PO #</th>
                      <th>PO Date</th>
                      <th>Device Type</th>
                      <th># of Devices</th>
                      <th>Active Device</th>
                      <th>Start Date</th>
                      <th class="text-center">Contract Copy</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="licenceData && licenceData.length > 0; else noData">
                    <tr *ngFor="let licence of licenceData; let idx = index">
                      <td>{{licence?.company_name || '--'}}</td>
                      <td>{{licence?.po || '--'}}</td>
                      <td>{{licence?.po_date || '--'}}</td>
                      <td>{{licence?.device_type || '--'}}</td>
                      <td>{{licence?.number_of_licence || '--'}}</td>
                      <td>{{licence?.active_devices || '--'}}</td>
                      <td>{{licence?.created_at || '--'}}</td>
                      <td class="text-center" >
                          <div class="upload-icon-wrapper" *ngIf="licence.contract_copy !== ''">
                            <span class="sprite_icon pdf_green" (click)="viewPDFInfo(licence.contract_copy)"></span>
                         </div>
                          <div class="upload-icon-wrapper" *ngIf="licence.contract_copy === ''">
                            <span class="sprite_icon pdf_yellow"></span>
                            <input type="file" name="myfile" accept="pdf/*" ng2FileSelect [uploader]="uploader" (change)="upload($event.target.files, licence.id)">
                         </div>
                      </td>
                      <td>
                          <span class="material-icons font_16 hand_cursor" (click)="editLicenseType(licence.id)">create</span>
                      </td>
                    </tr>
                    </ng-container>
                    <ng-template #noData>
                      <tr>
                        <td colspan="9" class="text-center">No licence data available.</td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>
          </div>
        </div>
      </div>
    </div>
</div>
